import { getAuthentication } from '@/hooks/useAuthentication';
import axios from 'axios';

export interface LikeProps {
  id: string;
  type: 'INSIGHT' | 'KNOWLEDGE_BASE' | 'LEARN' | 'PODCAST' | 'WILDCARD';
  moduleId?: string;
  lessonId?: string;
}

export const likeEntity = async (likeData: LikeProps) => {
  let data, error;

  try {
    const context = getAuthentication();
    const { data: response } = await axios({
      method: 'post',
      url: `${import.meta.env.VITE_API_URL}/api/like`,
      data: likeData,
      headers: {
        Authorization: `Bearer ${context.accessToken}`,
      },
    });

    data = response;
  } catch (err) {
    console.error(err);
    // eslint-disable-next-line import/no-named-as-default-member
    if (axios.isAxiosError(err) && err.response) {
      error = err.response?.data?.error;
    }
  }

  return { data, error };
};

export const countLikes = async (likeData: LikeProps) => {
  let data: { likes: number; likedByUser: boolean } = { likes: 0, likedByUser: false };
  let error;

  try {
    const context = getAuthentication();
    const { data: response } = await axios({
      method: 'post',
      url: `${import.meta.env.VITE_API_URL}/api/like-count`,
      data: likeData,
      headers: {
        Authorization: `Bearer ${context.accessToken}`,
      },
    });

    data = response;
  } catch (err) {
    console.error(err);
    // eslint-disable-next-line import/no-named-as-default-member
    if (axios.isAxiosError(err) && err.response) {
      error = err.response?.data?.error;
    }
  }

  return { data, error };
};
